window.addEventListener('DOMContentLoaded', (event) => {
	const { v4: uuidv4 } = require('uuid');
	const uuid = document.querySelector(
		'.gform_hidden > .ginput_container > .gform_hidden'
	);

	// Generate UUID to used later
	if (uuid) {
		const categoryForm = document.querySelector(
			'.survivor-stories__category-form'
		);

		if (categoryForm) {
			const localUUID = localStorage.getItem('uuid');

			if (localUUID) {
				uuid.value = localUUID;
			} else {
				const share = document.getElementById('start-survivor-story');

				if (share) {
					window.location = share.value;
				}
			}
		} else {
			uuid.value = uuidv4();
		}

		uuid.value = categoryForm ? localStorage.getItem('uuid') : uuidv4();
		localStorage.setItem('uuid', uuid.value);
	}

	// Handle changes to remove error state colour
	document
		.querySelectorAll('.ginput_container > input, select, textarea')
		.forEach(function (ele) {
			ele.addEventListener('input', function (e) {
				e?.target?.parentElement?.parentElement?.classList.remove(
					'gfield_error'
				);
			});
		});

	const selects = document.querySelectorAll('.aftermetoo__select');

	selects.forEach(function (select) {
		const checkboxContainer = document.getElementById(
			select.dataset.controls
		).parentElement;

		select.addEventListener('click', function (e) {
			selects.forEach(function (s) {
				if (select.id !== s.id) {
					const checkboxContainer = document.getElementById(
						s.dataset.controls
					).parentElement;

					if (
						checkboxContainer.classList.contains(
							'survivor-stories__select--visible'
						)
					) {
						s.click();
					}
				}
			});

			if (checkboxContainer) {
				checkboxContainer.classList.toggle(
					'survivor-stories__select--visible'
				);

				if (
					checkboxContainer.classList.contains(
						'survivor-stories__select--visible'
					)
				) {
					select.setAttribute('aria-expanded', 'true');
				} else {
					select.setAttribute('aria-expanded', 'false');
				}
			}
		});

		const sibling = select.parentElement.nextSibling;
		const firstChoice = sibling.querySelector('.gchoice');
		const label = firstChoice.querySelector('label');

		firstChoice.addEventListener('click', function (e) {
			select.click();
		});

		label.addEventListener('click', function (e) {
			select.click();
		});

		select.addEventListener('keyup', function (e) {
			if (e.Code === 'Space' || e.keyCode === 32) {
				select.click();
			}
		});
	});

	document.addEventListener('click', function (e) {
		if (
			!e.target.parentNode.classList.contains('gchoice') &&
			!e.target.tagName !== 'LABEL' &&
			!e.target.classList.contains('aftermetoo__select') &&
			!e.target.classList.contains('gfield-choice-input')
		) {
			const selects = document.querySelectorAll('.aftermetoo__select');

			selects.forEach(function (select) {
				const checkboxContainer = document.getElementById(
					select.dataset.controls
				).parentElement;

				if (
					checkboxContainer.classList.contains(
						'survivor-stories__select--visible'
					)
				) {
					select.click();
				}
			});
		}

		// Remove tag
		if (e.target.classList.contains('share-your-story-form__remove-tag')) {
			e.preventDefault();
			const id = e.target.dataset.id;

			if (id) {
				const checkbox = document.getElementById(id);

				if (checkbox) {
					checkbox.checked = false;
				}

				e.target.parentElement.remove();
			}
		}

		return false;
	});

	document.addEventListener('keyup', function (e) {
		// Escape
		if (e.keyCode === 27 || e.key === 'Escape') {
			const selects = document.querySelectorAll('.aftermetoo__select');
			selects.forEach(function (select) {
				const checkboxContainer = document.getElementById(
					select.dataset.controls
				).parentElement;

				if (
					checkboxContainer.classList.contains(
						'survivor-stories__select--visible'
					)
				) {
					select.click();
				}
			});
		}
	});

	// Populate tag area
	const tagArea = document.querySelector('.share-your-story-form__tags');

	if (tagArea) {
		const checkBoxes = document.querySelectorAll('.gfield-choice-input');
		const history = document.getElementById('history');

		checkBoxes.forEach(function (checkbox) {
			const id = checkbox.id;
			const label = document.querySelector(`[for="${id}"]`);

			const template = `<span>
          ${label.innerHTML}
        </span>
        <button class="share-your-story-form__remove-tag" data-id="${id}" aria-label="${app.remove_tag}">      
        </button>
      `;

			const tag = document.createElement('div');
			tag.classList.add('share-your-story-form__tag');
			tag.innerHTML = template;
			tag.setAttribute('data-source', id);

			// Add event listener
			checkbox.addEventListener('change', function (e) {
				if (label) {
					const tagCheck = tagArea.querySelector(
						`[data-source="${id}"]`
					);

					// Add
					if (!tagCheck && checkbox.value !== '') {
						tagArea.append(tag);
					} else {
						// Remove
						tagCheck.remove();
					}
				}
			});
		});
	}

	const thankYouPage = document.getElementById('share-story-thankyou-page');
	if (thankYouPage) {
		localStorage.removeItem('uuid');
	}
});
